import React from "react";

import { contentTranslation } from "data/about/translationAbout";

const AboutContent = (props) => {
    return (
        <section className="about-content-section">
            {contentTranslation.map((content, idx) => {
                return (
                    <p
                        key={`about-content-${idx}`}
                        dangerouslySetInnerHTML={{
                            __html: content[props.language],
                        }}
                    ></p>
                );
            })}
        </section>
    );
};

export default AboutContent;
